module.exports = __webpack_public_path__ + "media/images/new-ui-images/pre-arrow-hover-ada21033c63a73212c27a8ffad2b04e5.svg";